import React, { Component } from "react";
import { HashLink as Link } from 'react-router-hash-link';

class Header extends Component {

    render() {
        return (
            <header className="cm-header" id="top">
                <div className="header-top bg-black">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-10">
                                <div className="d-block d-md-flex justify-content-center justify-content-xl-start">
                                    <div className="block text-gray mr-35">
                                        <span className="icon text-primary fas fa-phone-alt mr-15" />
                                        <a href="tel: +39 370 362 9236" style={{color:"#cecece"}} target="_blank">+39 3703629236</a>
                                        </div>
                                    <div className="block text-gray mr-35">
                                        <span className="icon text-primary fas fa-envelope mr-15" />
                                        <a href="mailto:info@fiorentinabaseball.it" style={{color:"#cecece"}} target="_blank">info@fiorentinabaseball.it</a>
                                    </div>
                                    <div className="block text-gray">
                                        <span className="icon text-primary fas fa-home mr-15" />
                                        <a rel="noopener noreferrer" style={{color:"#cecece"}} href="https://what3words.com/fagiani.omaggio.voluto" target="_blank">V.le M. Fanti, 18 – I 50137 Firenze</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 d-none d-xl-block">
                                <div className="block d-flex justify-content-end">
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/FiorentinaBaseball"><span className="icon fab fa-facebook-f border-right-0" /></a>
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCBer3-yW7f3w1kUV1XbluZw"><span className="icon fab fa-youtube border-right-0" /></a>
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/fiorentinabaseballsoftball"><span className="icon fab fa-instagram border-right-0" /></a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="row justify-content-center ">
                            <h4>Orari Segreteria: Mercoledi e Giovedi 18:00 - 19:30 </h4>
                            </div>
                <div className="header">
                    <div className="container h-100">
                        <div className="row h-100 align-content-center">
                            <div className="col-md-12">
                                <nav className="navbar navbar-expand-lg navbar-light px-0">
                                    <Link className="navbar-brand initiate-scripts" to={'/home'}>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/logoFiorentina.png'} alt="logo" />
                                    </Link>
                                    <button
                                        className="navbar-toggler border-0 p-0"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#navLinks"
                                        aria-controls="navLinks"
                                        aria-expanded="false">

                                        <span className="navbar-toggler-icon" />
                                    </button>

                                    <div className="collapse navbar-collapse" id="navLinks">
                                        <ul className="navbar-nav ml-auto align-items-center">
                                            <li className="nav-item">
                                                <Link className="nav-link dropdown-toggle initiate-scripts" to="/home">
                                                    Home
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link initiate-scripts" to='/fixtures'>Calendari</Link>
                                            </li>
                                            {/* <li className="nav-item">
                                                <Link to="/home#news" className="nav-link dropdown-toggle initiate-scripts" spy="true" smooth>
                                                    News
                                                </Link>
                                            </li> */}
                                            <li className="nav-item">
                                                <Link to="/home#staff" className="nav-link dropdown-toggle initiate-scripts" spy="true" smooth>
                                                    Staff
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/home#history" className="nav-link dropdown-toggle initiate-scripts" spy="true" smooth>
                                                    Storia
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/home#shop" className="nav-link dropdown-toggle initiate-scripts" smooth>
                                                    Shop
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link initiate-scripts" to='/teams'>Teams</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link initiate-scripts" to='/news'>News</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header >
        );
    }
}

export default Header;